import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'ljit-store-connecter';
import { usePrevious } from '../../lib/react-utils';
import { LanguageCodeEnums } from '../../lib/enums';
import { changeLanguage } from '../../lib/i18n';
import { languageActions } from '../controller';

const { EN, BN } = LanguageCodeEnums;
const {
	setLanguage,
} = languageActions;
const propTypes = {
	setLanguage: PropTypes.func,
	meData: PropTypes.object.isRequired,
	language: PropTypes.string.isRequired,
	render: PropTypes.func.isRequired,
};
const defaultProps = {
	render: () => {},
};

function I18nRoute({
	setLanguage,
	meData,
	language,
	render,
}) {
	const prevLanguage = usePrevious(language);

	useEffect(() => {
		if (
			meData.languageCode &&
			prevLanguage !== meData.languageCode
		) {
			const { languageCode } = meData;

			// TODO 當 languageCode === 'bn'，介面設定 'en'，補上 bn 文檔後，改回 languageCode
			changeLanguage(BN === languageCode ? EN : languageCode);
			setLanguage(languageCode);
		}
	}, [meData.languageCode]);

	// For Switch 11 Language
	useEffect(() => {
		if (language && language !== prevLanguage) {
			changeLanguage(language);
		}
	}, [language]);

	return render();
}

function mapStateToProps(state) {
	return {
		meData: state.auth.get('me').toObject(),
		language: state.language.get('data'),
	};
}

function mapDispatchToProps(dispatch) {
	return {
		setLanguage: language => dispatch(setLanguage(language)),
	};
}

I18nRoute.propTypes = propTypes;
I18nRoute.defaultProps = defaultProps;

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(I18nRoute));
